import { APPROVE_BIKE_STATUS, APPROVE_COUPON_STATUS, COUPON_TYPE, DURATION_TIME_TYPE, LANGUAGES_SUPPORTED, LanguagesSupported, LOCATION_TYPE, PROGRESS_STATUS, ROLE_USER, STATUS, OPTION_FORMAT, OPTION_TYPE_VALUE, ORDER_STATUS, BIKE_STATUS, REFUND_STATUS, NEWS_TYPE, PAYMENT_STATUS, DRIVER_LICENSE_STATUS_TYPE, REGISTER_STATUS, ADDITIONAL_PAYMENT_TYPE, HONORIFIC_TITLE_TYPE, PAYMENT_TYPE, PAYMENT_HISTORY_STATUS, INSURENCE_OPTION, DROPOFF_OPTION, GROUP_CAPACITY_TYPE, GEARBOX, LICENSE_TYPE_OPTION, CAPACITY_BIKE, SEAT_HEIGHT } from '@/types/enums';
import { LanguageInfo } from '@/types/language';
import { Coordinate, Coordination } from '@/types/location';
import { Route } from '@/types/routes';
import { PaginationState } from '@tanstack/react-table';
import { enUS, ja } from 'date-fns/locale';
import { URL_CONFIG } from './environment';

export const BB_MAIL = 'info@bestbike.co.jp';
export const ekDomain = 'kickboard';
export const timeZone = 'Asia/Tokyo';
export const cookieNameBesBikeShared = 'bestbike_logged_in_shared';
export const kickboardClassName: string = 'kickboard';
export const IMAGE_TYPES = {
    TYPE: {
        'image/jpeg': true,
        'image/jpg': true,
        'image/png': true
    },
    EXTENSIONS: ['jpg', 'jpeg', 'png']
};

// #region Routes
enum RoutesKey {
    home,
    comingSoon,
    dashboard,
    signin,
    signup,
    signup2,
    signup3,
    forgetPassword,
    resetPassword,
    setPassword,
    userManagement,
    userCreate,
    userEdit,
    userDetail,
    myAccount,
    locationManagement,
    locationCreate,
    locationEdit,
    locationDetail,
    optionManagement,
    newsCreate,
    newsEdit,
    newsList,
    newsDetail,
    otherSetting,
    systemSetting,
    kilometerLimitManagement,
    couponSetting,
    inquiryEnduser,
    approveManagement,
    companyIntroduction,
    privacyPolicy,
    termsAndConditions,
    specialCommercial,
    cancellationPolicy,
    approveBikes,
    couponCreate,
    couponEdit,
    bikeManagement,
    bikeCreate,
    bikeEdit,
    bikeDetail,
    priceManagement,
    priceCreate,
    priceEdit,
    priceDetail,
    priceList,
    locationList,
    locationDetailEnduser,
    revenueManagement,
    revenueDetail,
    commissionManagement,
    commissionOwnerMontly,
    reservationManagement,
    reservationDetail,
    reservationReportBike,
    reservationReportHistory,
    reservationReturnHistory,
    reservationReportHistoryEnduser,
    reservationReturnHistoryEnduser,
    reservationEdit,
    bikeBookingDetail,
    bikeBookingFirst,
    bikeBookingSecond,
    bikeBookingThird,
    paymentStatus,
    bikeReturn,
    locationCurrentList
};

export const ROUTES: Record<keyof typeof RoutesKey, Route> = {
    home: {
        href: `${URL_CONFIG.DOMAIN_WORDPRESS.url}`,
        hrefEK: `${URL_CONFIG.DOMAIN_WORDPRESS.url}${ekDomain}`,
        title: 'words_title.home',
        menuLabel: 'words_title.home',
        breadcrumbLabel: 'words_title.home'
    },
    comingSoon: {
        href: 'coming-soon',
        hrefEK: 'coming-soon',
        title: '',
        menuLabel: '',
        breadcrumbLabel: ''
    },
    dashboard: {
        href: '/dashboard',
        hrefEK: '/dashboard',
        menuLabel: 'words_title.dashboard',
        breadcrumbLabel: 'words_title.dashboard'
    },
    signin: {
        href: '/sign-in',
        hrefEK: '/sign-in',
        title: 'words_title.sign_in',
        menuLabel: ''
    },
    signup: {
        href: '/customer/register',
        hrefEK: 'customer/register',
        title: 'words_title.sign_up',
        menuLabel: ''
    },
    signup2: {
        href: '/customer/registration',
        hrefEK: 'customer/registration',
        title: 'words_title.sign_up',
        menuLabel: ''
    },
    signup3: {
        href: '/customer/register-step-3',
        hrefEK: 'customer/register-step-3',
        title: 'words_title.sign_up',
        menuLabel: ''
    },
    forgetPassword: {
        href: '/forget-password',
        hrefEK: 'forget-password',
        title: '',
        menuLabel: ''
    },
    resetPassword: {
        href: 'users/forget-password',
        hrefEK: 'users/forget-password',
        title: '',
        menuLabel: ''
    },
    setPassword: {
        href: 'users/set-password',
        hrefEK: 'users/set-password',
        title: '',
        menuLabel: ''
    },

    // #region Bike route
    bikeManagement: {
        href: '/bikes-management',
        hrefEK: 'bikes-management',
        title: 'words_title.bike_management',
        menuLabel: 'words_title.bike_management',
        breadcrumbLabel: 'words_title.bike_management'
    },
    bikeCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.bike_create',
        menuLabel: 'words_title.bike_management',
        breadcrumbLabel: 'words_title.bike_create',
        pathKey: 'bikes-management/create',
        showBtnBack: true
    },
    bikeEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.bike_detail',
        menuLabel: 'words_title.bike_detail',
        breadcrumbLabel: 'words_title.bike_detail',
        pathKey: 'bikes-management/edit',
        showBtnBack: true
    },
    bikeDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.bike_detail',
        menuLabel: 'words_title.bike_management',
        breadcrumbLabel: 'words_title.bike_detail',
        pathKey: 'bikes-management/detail',
        showBtnBack: true
    },
    // #endregion bike route

    // #region Booking bike route
    bikeBookingDetail: {
        href: 'bike-detail',
        hrefEK: 'bike-detail',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'bike-detail'
    },
    bikeBookingFirst: {
        href: 'bike-booking-first',
        hrefEK: 'bike-booking-first',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'bike-booking-first'
    },
    bikeBookingSecond: {
        href: 'bike-booking-second',
        hrefEK: 'bike-booking-second',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'bike-booking-second'
    },
    bikeBookingThird: {
        href: 'bike-booking-third',
        hrefEK: 'bike-booking-third',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'bike-booking-third'
    },
    bikeReturn: {
        href: 'bike-return',
        hrefEK: 'bike-return',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'bike-return'
    },
    // #endregion Booking bike route

    // #region Payment status route
    paymentStatus: {
        href: 'customer/orders/payment-status',
        hrefEK: 'customer/orders/payment-status',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'customer/orders/payment-status'
    },
    // #endregion Payment status route

    // #region Account route
    userManagement: {
        href: '/accounts-management',
        hrefEK: '/accounts-management',
        title: 'words_title.account_management',
        menuLabel: 'words_title.account_management',
        breadcrumbLabel: 'words_title.account_management'
    },
    userCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.account_create',
        menuLabel: 'words_title.account_create',
        breadcrumbLabel: 'words_title.account_create',
        pathKey: 'accounts-management/create',
        showBtnBack: true
    },
    userEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.account_detail',
        menuLabel: 'words_title.account_detail',
        breadcrumbLabel: 'words_title.account_detail',
        pathKey: 'accounts-management/edit',
        showBtnBack: true
    },
    userDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.account_detail',
        menuLabel: 'words_title.account_detail',
        breadcrumbLabel: 'words_title.account_detail',
        pathKey: 'accounts-management/detail',
        showBtnBack: true
    },
    myAccount: {
        href: '/my-account',
        hrefEK: 'my-account',
        title: '',
        menuLabel: '',
        breadcrumbLabel: '',
        pathKey: 'my-account'
    },
    // #endregion Account route
    // #region Location route
    locationManagement: {
        href: '/locations-management',
        hrefEK: 'locations-management',
        title: 'words_title.location_management',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_management'
    },
    locationCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.location_create',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_create',
        pathKey: 'locations-management/create',
        showBtnBack: true
    },
    locationEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.location_detail',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_detail',
        pathKey: 'locations-management/edit',
        showBtnBack: true
    },
    locationDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.location_detail',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_detail',
        pathKey: 'locations-management/detail',
        showBtnBack: true
    },
    // #endregion Location route

    // #region Location enduser route
    locationList: {
        href: 'locations-eu',
        hrefEK: 'locations-eu',
        title: 'words_title.location_management',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_management'
    },
    locationCurrentList: {
        href: 'current-locations',
        hrefEK: 'current-locations',
        title: 'words_title.location_management',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_management'
    },
    locationDetailEnduser: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.location_search_list',
        menuLabel: 'words_title.location_search_list',
        breadcrumbLabel: 'words_title.location_search_list',
        pathKey: 'locations/detail'
    },
    // #endregion Location enduser route

    // #region  Option
    optionManagement: {
        href: '/option',
        hrefEK: '/option',
        title: 'words_title.option_management',
        menuLabel: 'words_title.option_management',
        breadcrumbLabel: 'words_title.option_management'
    },
    // #endregion Option

    // #region News Management
    newsCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.news_create',
        menuLabel: 'words_title.news_create',
        breadcrumbLabel: 'words_title.news_create',
        pathKey: 'news-management/create',
        showBtnBack: true
    },
    newsEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.news_edit',
        menuLabel: 'words_title.news_edit',
        breadcrumbLabel: 'words_title.news_edit',
        pathKey: 'news-management/edit',
        showBtnBack: true
    },
    newsList: {
        href: '/news',
        hrefEK: 'news',
        title: 'words_title.news_list',
        menuLabel: 'words_title.news_list',
        breadcrumbLabel: 'words_title.news_list'
    },
    newsDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.news_detail',
        menuLabel: 'words_title.news_detail',
        breadcrumbLabel: 'words_title.news_detail',
        pathKey: 'news/detail'
    },
    // #endregion News Management

    otherSetting: {
        href: '/setting',
        hrefEK: '/setting',
        title: 'words_title.other_setting',
        menuLabel: 'words_title.other_setting',
        breadcrumbLabel: 'words_title.other_setting'
    },

    // #region system setting route
    systemSetting: {
        href: '/setting/system',
        hrefEK: 'system',
        title: 'words_title.system_setting',
        menuLabel: 'words_title.system_setting',
        breadcrumbLabel: 'words_title.system_setting',
        pathKey: 'setting/system'
    },
    kilometerLimitManagement: {
        href: '/setting/kilometer-limit',
        hrefEK: 'setting/kilometer-limit',
        title: 'words_title.kilometer_limit',
        menuLabel: 'words_title.mileage_and_dropoff',
        breadcrumbLabel: 'words_title.kilometer_limit',
        pathKey: 'setting/kilometer-limit'
    },
    // #endregion system setting route

    // #region coupon route
    couponSetting: {
        href: '/coupons-management',
        hrefEK: 'coupons-management',
        title: 'words_title.coupon_management',
        menuLabel: 'words_title.coupon_management',
        breadcrumbLabel: 'words_title.coupon_management'
    },
    couponCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.coupon_create',
        menuLabel: 'words_title.coupon_management',
        breadcrumbLabel: 'words_title.coupon_create',
        pathKey: 'coupons-management/create',
        showBtnBack: true
    },
    couponEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.coupon_detail',
        menuLabel: 'words_title.coupon_management',
        breadcrumbLabel: 'words_title.coupon_detail',
        pathKey: 'coupons-management/edit',
        showBtnBack: true
    },
    // #endregion coupon route

    // #region Inquiry Management
    inquiryEnduser: {
        href: '/inquiry',
        hrefEK: 'inquiry',
        title: 'words_title.contact_us',
        menuLabel: 'words_title.contact_us',
        breadcrumbLabel: 'words_title.contact_us'
    },
    // #endregion Inquiry Management

    // #region Content setting
    companyIntroduction: {
        href: '/company-introduction',
        hrefEK: 'company-introduction',
        title: 'words_title.company_introduction',
        menuLabel: 'words_title.company_introduction',
        breadcrumbLabel: 'words_title.company_introduction'
    },
    privacyPolicy: {
        href: '/privacy-policy',
        hrefEK: 'privacy-policy',
        title: 'words_title.privacy_policy',
        menuLabel: 'words_title.privacy_policy',
        breadcrumbLabel: 'words_title.privacy_policy'
    },
    termsAndConditions: {
        href: '/terms-and-conditions',
        hrefEK: 'terms-and-conditions',
        title: 'words_title.terms_and_conditions',
        menuLabel: 'words_title.terms_and_conditions',
        breadcrumbLabel: 'words_title.terms_and_conditions'
    },
    specialCommercial: {
        href: '/special-commercial',
        hrefEK: 'special-commercial',
        title: 'words_title.special_commercial',
        menuLabel: 'words_title.special_commercial',
        breadcrumbLabel: 'words_title.special_commercial'
    },
    cancellationPolicy: {
        href: '/cancellation-policy',
        hrefEK: 'cancellation-policy',
        title: 'words_title.cancellation_policy',
        menuLabel: 'words_title.cancellation_policy',
        breadcrumbLabel: 'words_title.cancellation_policy'
    },
    // #endregion Content setting

    // #region approve route
    approveManagement: {
        href: '/approve',
        hrefEK: '/approve',
        title: 'words_title.approve_management',
        menuLabel: 'words_title.approve_management',
        breadcrumbLabel: 'words_title.approve_management'
    },
    approveBikes: {
        href: '/approve/bikes',
        hrefEK: 'approve/bikes',
        title: 'words_title.approve_bikes',
        menuLabel: 'words_title.approve_bikes',
        breadcrumbLabel: 'words_title.approve_bikes'
    },
    // #endregion approve route

    // #region price management route
    priceManagement: {
        href: '/prices-management',
        hrefEK: 'prices-management',
        title: 'words_title.price_management',
        menuLabel: 'words_title.price_management',
        breadcrumbLabel: 'words_title.price_management'
    },
    priceCreate: {
        href: 'create',
        hrefEK: 'create',
        title: 'words_title.add_price_management',
        menuLabel: 'words_title.add_price_management',
        breadcrumbLabel: 'words_title.add_price_management',
        pathKey: 'prices-management/create',
        showBtnBack: true
    },
    priceEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: 'words_title.edit_price_management',
        menuLabel: 'words_title.edit_price_management',
        breadcrumbLabel: 'words_title.edit_price_management',
        pathKey: 'prices-management/edit',
        showBtnBack: true
    },
    priceDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.view_price',
        menuLabel: 'words_title.view_price',
        breadcrumbLabel: 'words_title.view_price',
        pathKey: 'prices-management/detail',
        showBtnBack: true
    },
    // prices-eu
    priceList: {
        href: 'price',
        hrefEK: 'price',
        // href: 'prices-eu',
        // hrefEK: 'prices-eu',
        title: 'price_list.rental_fee',
        menuLabel: 'words_title.rental_fee',
        breadcrumbLabel: 'words_title.rental_fee'
    },
    // #endregion price management

    // #region Revenue management route
    revenueManagement: {
        href: '/revenue-management',
        hrefEK: 'revenue-management',
        title: 'words_title.revenue_management',
        menuLabel: 'words_title.revenue_management',
        breadcrumbLabel: 'words_title.revenue_management'
    },
    revenueDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: 'words_title.revenue_detail',
        menuLabel: 'words_title.revenue_detail',
        breadcrumbLabel: 'words_title.revenue_detail',
        pathKey: 'revenue-management/detail',
        showBtnBack: true
    },
    // #endregion Revenue management

    // #region Commission Management route
    commissionManagement: {
        href: '/commission-management',
        hrefEK: 'commission-management',
        title: 'words_title.commission_management',
        menuLabel: 'words_title.commission_management',
        breadcrumbLabel: 'words_title.commission_management'
    },
    commissionOwnerMontly: {
        href: 'monthly-owner-commission-statistics',
        hrefEK: 'monthly-owner-commission-statistics',
        title: 'words_title.monthly_owner_commission_statistics',
        menuLabel: 'words_title.monthly_owner_commission_statistics',
        breadcrumbLabel: 'words_title.monthly_owner_commission_statistics',
        pathKey: 'commission-management/monthly-owner-commission-statistics',
        showBtnBack: true
    },
    // #endregion Commission Management

    // #region reservation
    reservationManagement: {
        href: '/reservation-management',
        hrefEK: 'reservation-management',
        title: 'words_title.reservation_management',
        menuLabel: 'words_title.reservation_management',
        breadcrumbLabel: 'words_title.reservation_management'
    },
    reservationDetail: {
        href: 'detail',
        hrefEK: 'detail',
        title: '',
        menuLabel: 'words_title.reservation_detail',
        breadcrumbLabel: 'words_title.reservation_detail',
        pathKey: 'reservation-management/detail',
        showBtnBack: true
    },
    reservationEdit: {
        href: 'edit',
        hrefEK: 'edit',
        title: '',
        menuLabel: 'words_title.reservation_details_update',
        breadcrumbLabel: 'words_title.reservation_details_update',
        pathKey: 'reservation-management/edit',
        showBtnBack: true
    },
    reservationReportBike: {
        href: 'report-bike',
        hrefEK: 'report-bike',
        title: '',
        menuLabel: 'words_title.report_bike',
        breadcrumbLabel: 'words_title.report_bike',
        pathKey: 'reservation-management/report-bike',
        showBtnBack: false
    },
    reservationReportHistory: {
        href: 'report-history',
        hrefEK: 'report-history',
        title: '',
        menuLabel: 'words_title.report_bike',
        breadcrumbLabel: 'words_title.report_bike',
        pathKey: 'reservation-management/report-history',
        showBtnBack: true
    },
    reservationReturnHistory: {
        href: 'return-history',
        hrefEK: 'return-history',
        title: 'words_title.bike_return',
        menuLabel: 'words_title.bike_return',
        breadcrumbLabel: 'words_title.bike_return',
        pathKey: 'reservation-management/return-history',
        showBtnBack: true
    },
    reservationReportHistoryEnduser: {
        href: '/my-account/rental-history/report-detail',
        hrefEK: 'my-account/rental-history/report-detail',
        title: 'words_title.report_bike',
        menuLabel: 'words_title.report_bike',
        breadcrumbLabel: 'words_title.report_bike',
        pathKey: 'my-account/rental-history/report-detail'
    },
    reservationReturnHistoryEnduser: {
        href: '/my-account/rental-history/return-detail',
        hrefEK: 'my-account/rental-history/return-detail',
        title: 'words_title.bike_return',
        menuLabel: 'words_title.bike_return',
        breadcrumbLabel: 'words_title.bike_return',
        pathKey: 'my-account/rental-history/return-detail'
    }
};

// #region Enduser react path
export const NO_LOGIN_PATH = {
    locationList: {
        href: 'locations-eu',
        hrefEK: 'locations-eu',
        title: 'words_title.location_management',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_management'
    },
    locationCurrentList: {
        href: 'current-locations',
        hrefEK: 'current-locations',
        title: 'words_title.location_management',
        menuLabel: 'words_title.location_management',
        breadcrumbLabel: 'words_title.location_management'
    },
    priceList: {
        href: 'price',
        hrefEK: 'price',
        // href: 'prices-eu',
        // hrefEK: 'prices-eu',
        title: 'price_list.rental_fee',
        menuLabel: 'words_title.rental_fee',
        breadcrumbLabel: 'words_title.rental_fee'
    },
    comingSoon: {
        href: 'coming-soon',
        hrefEK: 'coming-soon',
        title: '',
        menuLabel: '',
        breadcrumbLabel: ''
    },
    signin: {
        href: '/sign-in',
        hrefEK: '/sign-in',
        title: 'words_title.sign_in',
        menuLabel: ''
    },
    signup: {
        href: '/customer/register',
        hrefEK: 'customer/register',
        title: 'words_title.sign_up',
        menuLabel: ''
    },
    // signup2: {
    //     href: '/customer/registration',
    //     hrefEK: 'customer/registration',
    //     title: 'words_title.sign_up',
    //     menuLabel: ''
    // },
    // signup3: {
    //     href: '/customer/register-step-3',
    //     hrefEK: 'customer/register-step-3',
    //     title: 'words_title.sign_up',
    //     menuLabel: ''
    // },
    forgetPassword: {
        href: '/forget-password',
        hrefEK: 'forget-password',
        title: '',
        menuLabel: ''
    },
    resetPassword: {
        href: 'users/forget-password',
        hrefEK: 'users/forget-password',
        title: '',
        menuLabel: ''
    },
    setPassword: {
        href: 'users/set-password',
        hrefEK: 'users/set-password',
        title: '',
        menuLabel: ''
    }
};

export const isPathNoLogin = (path: string): boolean => {
    return Object.values(NO_LOGIN_PATH).some((route) => {
        if (path.includes('management') || path.includes(ROUTES.bikeBookingFirst.href) || path.includes(ROUTES.bikeBookingSecond.href) || path.includes(ROUTES.bikeBookingThird.href)) {
            return false;
        }
        return path.includes(route.href);
    });
};
// #endregion Enduser react path

export const COUPON_PATH = {
    FOREVER: 'forever',
    ONE_TIME: 'one-time'
};

export const MY_ACCOUNT_PATH = {
    myAccount: '',
    registrationLocation: 'registration-location',
    rentalHistory: 'rental-history'
};

export const WORDPRESS_PATH = {
    howTo: {
        href: 'howto',
        hrefEk: 'kickboard/kick-howto'
    },
    contact: {
        href: 'contact',
        hrefEk: 'kickboard/kick-contact'
    },
    privacypolicy: {
        href: 'privacypolicy',
        hrefEk: 'kickboard/kick-privacypolicy'
    },
    terms: {
        href: 'terms',
        hrefEk: 'kickboard/kick-terms'
    },
    about: {
        href: 'about',
        hrefEk: 'kickboard/kick-about'
    },
    aboutTokusho: {
        href: 'about/#link-tokusho',
        hrefEk: 'kickboard/kick-about/#link-tokusho'
    }

};

// #region Languages
export const DEFAULT_LANGUAGE: LanguagesSupported = LANGUAGES_SUPPORTED.Japanese;

export const LANGUAGES_MAPPER: {
    japanese: LanguageInfo,
    english: LanguageInfo
} = {
    japanese: {
        code: LANGUAGES_SUPPORTED.Japanese,
        fullname: 'words_title.japanese',
        shortName: 'JP',
        flag: 'jp',
        dateFns: ja
    },
    english: {
        code: LANGUAGES_SUPPORTED.English,
        fullname: 'words_title.english',
        shortName: 'EN',
        flag: 'gb',
        dateFns: enUS
    }
};
// #endredion

// #region Dates

export const DATE_YMD = 'yyyy/MM/dd';
export const DATE_YMD_2 = 'YYYY/MM/DD';
export const DATE_YMD_HMS = 'YYYY/MM/DD HH:mm:ss';
export const DATE_YMD_HMS_12H_FORMAT = 'DD/MM/YYYY hh:mm:ss A';
export const DISPLAY_FNS_DATE_YMD = 'dd/MM/yyyy';
export const DISPLAY_FNS_DATE_YMD_FOR_LABEL_CALENDAR = 'yyyy.MM';
export const DISPLAY_MOMENT_DATE_YMD = 'DD/MM/YYYY';
export const DISPLAY_MOMENT_TIME_HMS = 'HH:mm:ss';
export const DISPLAY_MOMENT_TIME_HM_AM_PM = 'hh:mm A';
export const DISPLAY_MOMENT_DATE_TIME_HM = 'DD/MM/YYYY hh:mm A';
export const DISPLAY_MOMENT_TIME_HM_AM_PM_2 = 'hh:mm:A';
export const DISPLAY_MOMENT_TIME_HM = 'HH:mm';
export const DISPPLAY_MOMENT_YMD_HM = 'YYYY/MM/DD HH:mm';
export const DISPPLAY_MOMENT_YM = 'YYYY/MM';
export const DISPPLAY_MOMENT_YMD = 'YYYY/MM/DD';
export const DATE_YMD_HM = 'yyyy/MM/dd HH:mm';
export const DATE_SUBMIT_YMD = 'YYYY-MM-DD';
export const DATE_TIME_SUBMIT_ISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const DATE_TIME_SUBMIT_ISO_JST = 'YYYY-MM-DDTHH:mm:ss.SSS+09:00';
export const DATE_TIME_ISO_NO_TIMEZONE = 'YYYY-MM-DDTHH:mm:ss';
export const DISPPLAY_MOMENT_YMD_HM_FULLWIDTH = 'YYYY/MM/DD　HH:mm';
export const DISPPLAY_MOMENT_YMD_15H = 'YYYY/MM/DD 15:00';

export const TIME_STEP_SELECT = 5;
export const VALID_DURATION_BOOKING = 30;

// use for submit api
export const SUBMIT_MOMENT_DATE_YMD = 'YYYY/MM/DD';
export const SUBMIT_MOMENT_DATE_YMD_HM = 'YYYY/MM/DD HH:mm';

export const NON_RENTAL_TYPES = {
    Day: 'day',
    Weekly: 'weekly',
    Monthly: 'monthly'
};

export const DAY_OF_WEEK = {
    Sunday: {
        key: 'sunday',
        value: 'sunday',
        shortName: 'sun'
    },
    Monday: {
        key: 'monday',
        value: 'monday',
        shortName: 'mon'
    },
    Tuesday: {
        key: 'tuesday',
        value: 'tuesday',
        shortName: 'tue'
    },
    Wednesday: {
        key: 'wednesday',
        value: 'wednesday',
        shortName: 'wed'
    },
    Thursday: {
        key: 'thursday',
        value: 'thursday',
        shortName: 'thu'
    },
    Friday: {
        key: 'friday',
        value: 'friday',
        shortName: 'fri'
    },
    Saturday: {
        key: 'saturday',
        value: 'saturday',
        shortName: 'sat'
    }
};

// #endregion

// #region Table

export const DEFAULT_SELECT_PAGE_SIZES: number[] = [5, 10, 20, 50, 100];

export const DEFAULT_PAGINATION: PaginationState = {
    pageIndex: 0,
    pageSize: 10
};

// #endregion

// #region Number

export const MAX_LENGTH_DEFAULT_INPUT = 255;
export const MAX_LENGTH_NUMBER = 12;
export const MAX_LENGTH_TEXTAREA = 500;
export const MAX_LENGTH_LINK = 500;
export const DEFAULT_BOOKING_LEAD_TIME = 48;
export const DEFAULT_IMAGE_LIMIT_SIZE = 20;
export const DEFAULT_PDF_LIMIT_SIZE = 50;

// #endregion

// #region Regex

export const PHONE_VALIDATE_REGEX = /^0\d{9}$/;
export const PASSWORD_VALIDATE_REGEX = /^.{6,}$/;
export const EMAIL_VALIDATE_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const EMAIL_VALIDATE_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@([a-zA-Z0-9-]+\.)+[a-zA-Z]{1,10}$/;
export const NUMBER_VALIDATE_REGEX_ONLY_HALF = /^\d*$/;
export const NUMBER_VALIDATE_REGEX = /^[0-9０-９]*$/;
export const NUMBER_FULL_VALIDATE_REGEX_ONLY_HALF = /^-?(\d+|\d*\.\d+)$/;
export const NUMBER_FULL_VALIDATE_REGEX = /^[\-−]?(?:[0-9０-９]+|[0-9０-９]*[\.．][0-9０-９]+)$/;
export const NUMBER_FULL_HALF_VALIDATE_REGEX = /^[0-9\uFF10-\uFF19]*$/;

// #endregion

// #region Coordinates
export const DEFAULT_COORDINATES: Coordinate = {
    lat: 35.6585805,
    lng: 139.7454329
};
export const DEFAULT_COORDINATION: Coordination = {
    latitude: 35.6585805,
    longitude: 139.7454329
};

// #endregion

// #region Location
export const RADIUS_AROUND_MY_POSITION = 30;

export const LOCATION_TYPES = {
    [LOCATION_TYPE.GAS]: {
        key: 'gas',
        value: LOCATION_TYPE.GAS
    },
    [LOCATION_TYPE.EK]: {
        key: 'ek',
        value: LOCATION_TYPE.EK
    }
};

export const LOCATION_SEARCH_TYPES = {
    All: 'all',
    Current: 'current_location',
    Area: 'area_location'
};

// #region Coupon

export const COUPON_TYPES = {
    [COUPON_TYPE.ONE_TIME_USE]: {
        key: 'one_time_use',
        value: COUPON_TYPE.ONE_TIME_USE
    },
    [COUPON_TYPE.FOREVER_USE]: {
        key: 'forever_use',
        value: COUPON_TYPE.FOREVER_USE
    }
};

export const COUPON_STATUS = {
    Unused: 0,
    Used: 1
};

// #endregion coupon

export const STATUS_TYPE = {
    Active: 1,
    Inactive: 2
} as const;

// #region Status
export const STATUS_CONFIG = {
    [STATUS.Active]: {
        key: 'active',
        color: 'text-green-1',
        value: STATUS.Active
    },
    [STATUS.Inactive]: {
        key: 'inactive',
        color: 'text-red-1',
        value: STATUS.Inactive
    }
};

export const APPROVE_BIKE_STATUS_CONFIG = {
    [APPROVE_BIKE_STATUS.WaittingApprove]: {
        key: 'waitting_approve',
        textColor: 'text-text-16',
        bgColor: 'bg-background-16',
        value: APPROVE_BIKE_STATUS.WaittingApprove
    },
    [APPROVE_BIKE_STATUS.ResendApprove]: {
        key: 're_send',
        textColor: 'text-text-17',
        bgColor: 'bg-background-17',
        value: APPROVE_BIKE_STATUS.ResendApprove
    },
    [APPROVE_BIKE_STATUS.Approve]: {
        key: 'approved',
        textColor: 'text-text-18',
        bgColor: 'bg-background-18',
        value: APPROVE_BIKE_STATUS.Approve
    },
    [APPROVE_BIKE_STATUS.Reject]: {
        key: 'rejected',
        textColor: 'text-text-19',
        bgColor: 'bg-background-19',
        value: APPROVE_BIKE_STATUS.Reject
    }
};

export const APPROVE_COUPON_STATUS_CONFIG = {
    [APPROVE_COUPON_STATUS.WaittingApprove]: {
        key: 'waitting_approve',
        textColor: 'text-text-16',
        bgColor: 'bg-background-16',
        value: APPROVE_COUPON_STATUS.WaittingApprove
    },
    [APPROVE_COUPON_STATUS.Approve]: {
        key: 'approved',
        textColor: 'text-text-18',
        bgColor: 'bg-background-18',
        value: APPROVE_COUPON_STATUS.Approve
    },
    [APPROVE_COUPON_STATUS.Reject]: {
        key: 'rejected',
        textColor: 'text-text-19',
        bgColor: 'bg-background-19',
        value: APPROVE_COUPON_STATUS.Reject
    }
};

export const ACC_STATUS_OPTION_SELECT = [
    {
        id: STATUS.Active,
        name: 'field.active'
    },
    {
        id: STATUS.Inactive,
        name: 'field.inactive'
    }
];

export const PROGRESS_STATUS_CONFIG = {
    [PROGRESS_STATUS.New]: {
        key: 'new',
        color: 'text-text-17',
        value: PROGRESS_STATUS.New
    },
    [PROGRESS_STATUS.InProgress]: {
        key: 'in_progress',
        color: 'text-text-16',
        value: PROGRESS_STATUS.InProgress
    },
    [PROGRESS_STATUS.Complete]: {
        key: 'complete',
        color: 'text-text-18',
        value: PROGRESS_STATUS.Complete
    }
};

export const OPTION_FORMAT_CONFIG = {
    [OPTION_FORMAT.Option]: {
        key: 'option',
        value: OPTION_FORMAT.Option
    },
    [OPTION_FORMAT.Insurance]: {
        key: 'insurance',
        value: OPTION_FORMAT.Insurance
    },
    [OPTION_FORMAT.DropOff]: {
        key: 'drop_off',
        value: OPTION_FORMAT.DropOff
    },
    [OPTION_FORMAT.ExtraMileage]: {
        key: 'extra_mileage',
        value: OPTION_FORMAT.ExtraMileage
    }
};

export const OPTION_TYPE_VALUE_CONFIG = {
    [OPTION_TYPE_VALUE.YesNo]: {
        key: 'yes_no',
        value: OPTION_TYPE_VALUE.YesNo
    },
    [OPTION_TYPE_VALUE.Number]: {
        key: 'number',
        value: OPTION_TYPE_VALUE.Number
    }
};

export const BIKE_STATUS_CONFIG = {
    [BIKE_STATUS.Available]: {
        key: 'available',
        textColor: 'text-[#3E9500]',
        value: BIKE_STATUS.Available
    },
    [BIKE_STATUS.Completed]: {
        key: 'available_at_rental_location',
        textColor: 'text-[#FF9500]',
        value: BIKE_STATUS.Completed
    },
    [BIKE_STATUS.Doing]: {
        key: 'in_operation',
        textColor: 'text-[#FF1111]',
        value: BIKE_STATUS.Doing
    },
    [BIKE_STATUS.Returned]: {
        key: 'returned',
        textColor: 'text-[#3B7CEC]',
        value: BIKE_STATUS.Returned
    },
    [BIKE_STATUS.LateReturn]: {
        key: 'overdue_rental',
        textColor: 'text-[#FF1111]',
        value: BIKE_STATUS.LateReturn
    }
};
// #endregion

// #region Role user
export const ROLE_USER_CONFIG = {
    [ROLE_USER.SYSTEM_ADMIN]: {
        key: 'ADMIN',
        value: ROLE_USER.SYSTEM_ADMIN,
        name: 'role.ADMIN'
    },
    [ROLE_USER.BEST_BIKE_ADMIN]: {
        key: 'BB',
        value: ROLE_USER.BEST_BIKE_ADMIN,
        name: 'role.BB'
    },
    [ROLE_USER.FRANCHISE_OWNER_PRM]: {
        key: 'FCPRM',
        value: ROLE_USER.FRANCHISE_OWNER_PRM,
        name: 'role.FCPRM'
    },
    [ROLE_USER.FRANCHISE_OWNER_STD]: {
        key: 'FCSTD',
        value: ROLE_USER.FRANCHISE_OWNER_STD,
        name: 'role.FCSTD'
    },
    [ROLE_USER.HOTEL_BIKE_OWNER]: {
        key: 'HO',
        value: ROLE_USER.HOTEL_BIKE_OWNER,
        name: 'role.HO'
    },
    [ROLE_USER.SHARE_BIKE_OWNER]: {
        key: 'SO',
        value: ROLE_USER.SHARE_BIKE_OWNER,
        name: 'role.SO'
    },
    [ROLE_USER.RENTAL_BIKE_OWNER_RD]: {
        key: 'RD',
        value: ROLE_USER.RENTAL_BIKE_OWNER_RD,
        name: 'role.RD'
    },
    [ROLE_USER.RENTAL_BIKE_OWNER_EK]: {
        key: 'EK',
        value: ROLE_USER.RENTAL_BIKE_OWNER_EK,
        name: 'role.EK'
    }
};

export const ROLE_SYSTEM_OPTION_SELECT = [
    {
        id: ROLE_USER.SYSTEM_ADMIN,
        name: 'role.ADMIN'
    },
    {
        id: ROLE_USER.BEST_BIKE_ADMIN,
        name: 'role.BB'
    },
    {
        id: ROLE_USER.FRANCHISE_OWNER_PRM,
        name: 'role.FCPRM'
    },
    {
        id: ROLE_USER.FRANCHISE_OWNER_STD,
        name: 'role.FCSTD'
    },
    {
        id: ROLE_USER.SHARE_BIKE_OWNER,
        name: 'role.SO'
    },
    {
        id: ROLE_USER.HOTEL_BIKE_OWNER,
        name: 'role.HO'
    },
    {
        id: ROLE_USER.RENTAL_BIKE_OWNER_RD,
        name: 'role.RD'
    },
    {
        id: ROLE_USER.RENTAL_BIKE_OWNER_EK,
        name: 'role.EK'
    }
];

export const ROLE_GAS_OPTION_SELECT: { id: number, name: string }[] = [
    // {
    //     id: ROLE_USER.SYSTEM_ADMIN,
    //     name: 'role.ADMIN'
    // },
    {
        id: ROLE_USER.RENTAL_BIKE_OWNER_RD,
        name: 'role.RD'
    },
    {
        id: ROLE_USER.SHARE_BIKE_OWNER,
        name: 'role.SO'
    },
    {
        id: ROLE_USER.FRANCHISE_OWNER_STD,
        name: 'role.FCSTD'
    },

    {
        id: ROLE_USER.FRANCHISE_OWNER_PRM,
        name: 'role.FCPRM'
    },
    {
        id: ROLE_USER.BEST_BIKE_ADMIN,
        name: 'role.BB'
    }
];

export const ROLE_EK_OPTION_SELECT: { id: number, name: string }[] = [
    // {
    //     id: ROLE_USER.SYSTEM_ADMIN,
    //     name: 'role.ADMIN'
    // },
    {
        id: ROLE_USER.RENTAL_BIKE_OWNER_EK,
        name: 'role.EK'
    },
    {
        id: ROLE_USER.HOTEL_BIKE_OWNER,
        name: 'role.HO'
    },
    {
        id: ROLE_USER.BEST_BIKE_ADMIN,
        name: 'role.BB'
    }
];
// #endregion

// #region Duration Time
export const DURATION_TIME_TYPES = {
    [DURATION_TIME_TYPE.TWENTY_FOUR_HOURS]: {
        key: 'field.price_time.hours_24',
        value: DURATION_TIME_TYPE.TWENTY_FOUR_HOURS
    },
    [DURATION_TIME_TYPE.ONE_WEEK]: {
        key: 'field.price_time.week_1',
        value: DURATION_TIME_TYPE.ONE_WEEK
    },
    [DURATION_TIME_TYPE.ONE_MONTH]: {
        key: 'field.price_time.month_1',
        value: DURATION_TIME_TYPE.ONE_MONTH
    },
    [DURATION_TIME_TYPE.PLUS_ONE_DAY]: {
        key: 'field.price_time.day_1',
        value: DURATION_TIME_TYPE.PLUS_ONE_DAY
    }
};
// #endregion

export const BIKE_TYPES = [
    { id: 1, name: 'Naked' },
    { id: 2, name: 'Sport' },
    { id: 3, name: 'American' },
    { id: 4, name: 'Street' },
    { id: 5, name: 'Scooter' },
    { id: 6, name: 'Touring' },
    { id: 7, name: 'Off-Road' },
    { id: 8, name: 'Business' },
    { id: 9, name: 'Other' }
];

// #region Bike manufacture
export const BIKE_MANUFATURE = [
    { id: 'honda', name: 'Honda' },
    { id: 'triumph', name: 'Triumph' },
    { id: 'indianMotorcycle', name: 'Indian Motorcycle' },
    { id: 'benelli', name: 'Benelli' },
    { id: 'yamaha', name: 'Yamaha' },
    { id: 'kawasaki', name: 'Kawasaki' },
    { id: 'harleyDavidson', name: 'Harley - Davidson' },
    { id: 'suzuki', name: 'Suzuki' },
    { id: 'ducati', name: 'Ducati' },
    { id: 'bmw', name: 'BMW' },
    { id: 'orther', name: 'Orther' }
];
// #endregion Bike manufacture

// #region Test EK Answers
export const TEST_EK_ANSWER = {
    QUESTION_1: true,
    QUESTION_2: false,
    QUESTION_3: false,
    QUESTION_4: true,
    QUESTION_5: true,
    QUESTION_6: false,
    QUESTION_7: true,
    QUESTION_8: false,
    QUESTION_9: false,
    QUESTION_10: false,
    QUESTION_11: false
};
// #endregion Test EK Answers

// #region Reservation
export const ORDER_STATUS_CMS = {
    [ORDER_STATUS.Not_Paid]: {
        key: 'words_title.not_paid',
        value: ORDER_STATUS.Not_Paid,
        color: 'text-[#FF9500]',
        bgColor: 'bg-[#FDFAE6]',
        border: 'border-[#FF9500]',
        bgLinear: 'bg-linear-orange'
    },
    [ORDER_STATUS.Paid]: {
        key: 'words_title.paid',
        value: ORDER_STATUS.Paid,
        color: 'text-[#3E9500]',
        bgColor: 'bg-[#EBFDE6]',
        border: 'border-[#3E9500]',
        bgLinear: 'bg-linear-green'
    },
    [ORDER_STATUS.Available]: {
        key: 'words_title.available_at_rental_location',
        value: ORDER_STATUS.Available,
        color: 'text-[#3B7CEC]',
        bgColor: 'bg-[#FDFAE6]',
        border: 'border-[#3B7CEC]',
        bgLinear: 'bg-linear-blue'
    },
    [ORDER_STATUS.Operation]: {
        key: 'words_title.in_operation',
        value: ORDER_STATUS.Operation,
        color: 'text-[#0CC763]',
        bgColor: 'bg-[#EBFDE6]',
        border: 'border-[#0CC763]',
        bgLinear: 'bg-linear-green'
    },
    [ORDER_STATUS.Return]: {
        key: 'words_title.bike_returned',
        value: ORDER_STATUS.Return,
        color: 'text-[#07E0E9]',
        bgColor: 'bg-[#E6FDFC]',
        border: 'border-[#07E0E9]',
        bgLinear: 'bg-linear-grey'
    },
    [ORDER_STATUS.Overdue]: {
        key: 'words_title.overdue_rental',
        value: ORDER_STATUS.Overdue,
        color: 'text-[#FE1212]',
        bgColor: 'bg-[#FDE9E6]',
        border: 'border-[#FE1212]',
        bgLinear: 'bg-linear-red'
    },
    [ORDER_STATUS.Cancel]: {
        key: 'words_title.cancel',
        value: ORDER_STATUS.Cancel,
        color: 'text-[#FF1111]',
        bgColor: 'bg-[#FDE9E6]',
        border: 'border-[#FF1111]',
        bgLinear: 'bg-linear-red'
    },
    [ORDER_STATUS.Add_Not_Paid]: {
        key: 'words_title.add_not_paid',
        value: ORDER_STATUS.Add_Not_Paid,
        color: 'text-[#FF9500]',
        bgColor: 'bg-[#FDFAE6]',
        border: 'border-[#FF9500]',
        bgLinear: 'bg-linear-orange'
    }
};

export const ORDER_STATUS_EU = {
    [ORDER_STATUS.Not_Paid]: {
        key: 'not_paid',
        value: ORDER_STATUS.Not_Paid,
        bgColor: 'bg-[#FF9500]'
    },
    [ORDER_STATUS.Paid]: {
        key: 'paid',
        value: ORDER_STATUS.Paid,
        bgColor: 'bg-[#3E9500]'
    },
    [ORDER_STATUS.Available]: {
        key: 'available_at_rental_location',
        value: ORDER_STATUS.Available,
        bgColor: 'bg-[#3B7CEC]'
    },
    [ORDER_STATUS.Return]: {
        key: 'bike_returned',
        value: ORDER_STATUS.Return,
        bgColor: 'bg-[#07E0E9]'
    },
    [ORDER_STATUS.Operation]: {
        key: 'in_operation',
        value: ORDER_STATUS.Operation,
        bgColor: 'bg-[#0CC763]'
    },
    [ORDER_STATUS.Cancel]: {
        key: 'cancel',
        value: ORDER_STATUS.Cancel,
        bgColor: 'bg-[#FF1111]'
    },
    [ORDER_STATUS.Overdue]: {
        key: 'overdue_rental',
        value: ORDER_STATUS.Overdue,
        bgColor: 'bg-[#FE1212]'
    },
    [ORDER_STATUS.Add_Not_Paid]: {
        key: 'add_not_paid',
        value: ORDER_STATUS.Add_Not_Paid,
        bgColor: 'bg-[#FF9500]'
    }
};

export const ORDER_STATUS_LIST = [
    ORDER_STATUS.Not_Paid,
    ORDER_STATUS.Paid,
    ORDER_STATUS.Available,
    ORDER_STATUS.Operation,
    ORDER_STATUS.Return,
    ORDER_STATUS.Overdue,
    ORDER_STATUS.Cancel,
    ORDER_STATUS.Add_Not_Paid
];

export const INSURENCE_SELECT_OPTION = {
    [INSURENCE_OPTION.SUBSCRIBE]: {
        label: '加入する',
        value: INSURENCE_OPTION.SUBSCRIBE
    },
    [INSURENCE_OPTION.NOT_SUBSCRIBE]: {
        label: '加入しない',
        value: INSURENCE_OPTION.NOT_SUBSCRIBE
    }
};

export const DROPOFF_SELECT_OPTION = {
    [DROPOFF_OPTION.ADD]: {
        label: '追加する',
        value: DROPOFF_OPTION.ADD
    },
    [DROPOFF_OPTION.NOT_ADD]: {
        label: '追加しない',
        value: DROPOFF_OPTION.NOT_ADD
    }
};
// #endregion

// #region Refund status
export const REFUND_STATUS_DATA = {
    [REFUND_STATUS.Refund]: {
        key: 'words_title.refunded',
        value: REFUND_STATUS.Refund,
        color: 'text-[#FF1111]'
    },
    [REFUND_STATUS.Not_Refund]: {
        key: 'words_title.not_yet_refunded',
        value: REFUND_STATUS.Not_Refund,
        color: 'text-[#FF1111]'
    }
};
// #endregion

// #region Additional Payment status
export const ADDITIONAL_REQUEST_PAYMENT_TYPE = {
    [ADDITIONAL_PAYMENT_TYPE.TACHIGOKE]: {
        key: 'field.tachigoke',
        value: ADDITIONAL_PAYMENT_TYPE.TACHIGOKE
    },
    [ADDITIONAL_PAYMENT_TYPE.OVER_MILEAGE]: {
        key: 'field.increased_kilometers_2',
        value: ADDITIONAL_PAYMENT_TYPE.OVER_MILEAGE
    },
    [ADDITIONAL_PAYMENT_TYPE.DROP_OFF]: {
        key: 'field.drop_off',
        value: ADDITIONAL_PAYMENT_TYPE.DROP_OFF
    },
    [ADDITIONAL_PAYMENT_TYPE.REPAIR_FEE]: {
        key: 'field.repair_charge',
        value: ADDITIONAL_PAYMENT_TYPE.REPAIR_FEE
    },
    [ADDITIONAL_PAYMENT_TYPE.OTHER]: {
        key: 'words_title.other',
        value: ADDITIONAL_PAYMENT_TYPE.OTHER
    }
};

export const SORT_ADDITIONAL_REQUEST_PAYMENT_TYPE = [ADDITIONAL_PAYMENT_TYPE.TACHIGOKE, ADDITIONAL_PAYMENT_TYPE.REPAIR_FEE, ADDITIONAL_PAYMENT_TYPE.OVER_MILEAGE, ADDITIONAL_PAYMENT_TYPE.DROP_OFF, ADDITIONAL_PAYMENT_TYPE.OTHER];
// #endregion

// #region Payment
export const PAYMENT_TYPE_OBJECT = {
    [PAYMENT_TYPE.ORDER_CREATE]: {
        key: 'field.reserved_bike',
        label: 'booking_bike.title.book_a_bike',
        value: PAYMENT_TYPE.ORDER_CREATE
    },
    [PAYMENT_TYPE.UPDATE_ORDER]: {
        key: 'field.update_reservation',
        label: 'field.update_reservation',
        value: PAYMENT_TYPE.UPDATE_ORDER
    },
    [PAYMENT_TYPE.OTHER]: {
        key: 'field.payment_other',
        label: 'field.payment_other',
        value: PAYMENT_TYPE.OTHER
    }
};

// #endregion

// #region News type
export const NEWS_TYPE_DATA = {
    [NEWS_TYPE.NEW_NEWS]: {
        key: 'news.new_news',
        value: NEWS_TYPE.NEW_NEWS
    },
    [NEWS_TYPE.NOTIFICATIONS]: {
        key: 'news.notifications',
        value: NEWS_TYPE.NOTIFICATIONS
    },
    [NEWS_TYPE.BIKE_INFO]: {
        key: 'news.bike_info',
        value: NEWS_TYPE.BIKE_INFO
    },
    [NEWS_TYPE.LOCATION_INFO]: {
        key: 'news.location_infor',
        value: NEWS_TYPE.LOCATION_INFO
    }
};

export const NEWS_TYPE_SELECT = [
    {
        id: NEWS_TYPE.NEW_NEWS,
        name: 'news.new_news'
    },
    {
        id: NEWS_TYPE.NOTIFICATIONS,
        name: 'news.notifications'
    },
    {
        id: NEWS_TYPE.BIKE_INFO,
        name: 'news.bike_info'
    },
    {
        id: NEWS_TYPE.LOCATION_INFO,
        name: 'news.location_infor'
    }
];
// #endregion

// #region Payment status
export const PAYMENT_STATUS_DATA = {
    [PAYMENT_STATUS.NOT_PAID]: {
        key: 'words_title.not_paid',
        value: PAYMENT_STATUS.NOT_PAID,
        color: 'text-[#FF9500]'
    },
    [PAYMENT_STATUS.PAID_SUCCESS]: {
        key: 'words_title.symbol_paid_success',
        value: PAYMENT_STATUS.PAID_SUCCESS,
        color: 'text-[#4B7902]'
    },
    [PAYMENT_STATUS.PAID_FAIL]: {
        key: 'words_title.symbol_paid_fail',
        value: PAYMENT_STATUS.PAID_FAIL,
        color: 'text-[#D9001B]'
    }
};

export const PAYMENT_HISTORY_STATUS_DATA = {
    [PAYMENT_HISTORY_STATUS.NOT_PAID]: {
        key: 'payment_history.waiting_for_payment',
        value: PAYMENT_STATUS.NOT_PAID,
        color: 'text-primaryWeb'
    },
    [PAYMENT_HISTORY_STATUS.PAIDED]: {
        key: 'payment_history.paid',
        value: PAYMENT_STATUS.PAID_SUCCESS,
        color: 'text-[#3E9500]'
    },
    [PAYMENT_HISTORY_STATUS.REFUNDED]: {
        key: 'payment_history.refunded',
        value: PAYMENT_STATUS.REFUNDED,
        color: 'text-[#4B7902]'
    },
    [PAYMENT_HISTORY_STATUS.NOT_REFUNDED]: {
        key: 'payment_history.not_yet_refunded',
        value: PAYMENT_STATUS.NOT_REFUNDED,
        color: 'text-[#D9001B]'
    },
    [PAYMENT_HISTORY_STATUS.CANCELLED]: {
        key: 'payment_history.cancelled',
        value: PAYMENT_STATUS.CANCELLED,
        color: 'text-[#8C8C8C]'
    }
    // [PAYMENT_HISTORY_STATUS.NO_NEED_REFUNDED]: {
    //     key: 'payment_history.no_need_refund',
    //     value: PAYMENT_STATUS.NO_NEED_REFUNDED,
    //     color: 'text-[#FF1111]'
    // }
};
// #endregion

// #region Price status
export const PRICE_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1
};

export const PRICE_STATUS_CONFIG = {
    [PRICE_STATUS.INACTIVE]: {
        key: 'field.inactive',
        textColor: 'text-red-1',
        value: BIKE_STATUS.Available
    },
    [PRICE_STATUS.ACTIVE]: {
        key: 'field.active',
        textColor: 'text-green-1',
        value: BIKE_STATUS.Completed
    }
};
// #endregion Price status

// #region Driver license
export const DRIVER_LICENSE_STATUS_SELECT = [
    {
        value: DRIVER_LICENSE_STATUS_TYPE.VALID,
        name: 'driver_license.valid'
    },
    {
        value: DRIVER_LICENSE_STATUS_TYPE.EXPIRED,
        name: 'driver_license.expired'
    }
];

export const LICENSE_TYPE_OPTIONS = [
    {
        value: LICENSE_TYPE_OPTION.TRADITIONAL,
        name: '従来の免許証'
    },
    {
        value: LICENSE_TYPE_OPTION.MY_NUMBER,
        name: 'マイナ免許'
    }
];
// #endregion Driver license

// #region Server Error Message Code
export const SERVER_ERROR_MESSAGE_CODE = {
    SET_PASSWORD_INVALID: 'SET_PASSWORD_INVALID',
    ITEM_REQUIRED: 'ITEM_REQUIRED',
    LOGIN_FAIL: 'LOGIN_FAIL',
    PASSWORD_IS_EMPTY: 'PASSWORD_IS_EMPTY',
    EMAIL_HAS_BEEN_EXISTED: 'EMAIL_HAS_BEEN_EXISTED',
    EMAIL_DOSE_NOT_EXITS: 'EMAIL_DOSE_NOT_EXITS',
    EMAIL_IS_EMPTY: 'EMAIL_IS_EMPTY',
    EMAIL_NOT_MATCH_CONFIRM_EMAIL: 'EMAIL_NOT_MATCH_CONFIRM_EMAIL',
    EMAIL_INVALID: 'EMAIL_INVALID',
    EMAIL_SUBJECT_CREATE_ACCOUNT: 'EMAIL_SUBJECT_CREATE_ACCOUNT',
    ERROR_UNAUTHORIZED: 'ERROR_UNAUTHORIZED',
    ERROR_FORBIDDEN: 'ERROR_FORBIDDEN',
    SERVER_ERROR: 'SERVER_ERROR',
    ERROR: 'ERROR',
    ERROR_INVALID_TOKEN: 'ERROR_INVALID_TOKEN',
    PASSWORD_NOT_MATCH_CONFIRM_PASSWORD: 'PASSWORD_NOT_MATCH_CONFIRM_PASSWORD',
    PASSWORD_INVALID: 'PASSWORD_INVALID',
    ERROR_TYPE_IS_EMPTY: 'ERROR_TYPE_IS_EMPTY',
    ERROR_USER_IS_EXITS: 'ERROR_USER_IS_EXITS',
    USER_DOSE_NOT_EXITS: 'USER_DOSE_NOT_EXITS',
    ERROR_FAVORITE_LOCATION_LIMIT: 'ERROR_FAVORITE_LOCATION_LIMIT',
    ERROR_CAN_NOT_OCR: 'ERROR_CAN_NOT_OCR',
    ROLE_DOSE_NOT_EXITS: 'ROLE_DOSE_NOT_EXITS',
    ERROR_ABOUT_US_DOES_NOT_EXIST: 'ERROR_ABOUT_US_DOES_NOT_EXIST',
    ERROR_TERMS_DOES_NOT_EXIST: 'ERROR_TERMS_DOES_NOT_EXIST',
    ERROR_PRIVACY_POLICY_DOES_NOT_EXIST: 'ERROR_PRIVACY_POLICY_DOES_NOT_EXIST',
    ERROR_SPECIFIED_TRADE_DOES_NOT_EXIST: 'ERROR_SPECIFIED_TRADE_DOES_NOT_EXIST',
    ERROR_NEWSLETTER_DOES_NOT_EXIST: 'ERROR_NEWSLETTER_DOES_NOT_EXIST',
    ERROR_TITLE_NEWSLETTER_IS_EXIST: 'ERROR_TITLE_NEWSLETTER_IS_EXIST',
    ERROR_INQUERY_DOES_NOT_EXIST: 'ERROR_INQUERY_DOES_NOT_EXIST',
    ERROR_INQUERY_IS_COMPLETED: 'ERROR_INQUERY_IS_COMPLETED',
    ERROR_LOCATION_DOES_NOT_EXIST: 'ERROR_LOCATION_DOES_NOT_EXIST',
    ERROR_LOCATION_HAS_BEEN_REGISTERED_BY_BIKE: 'ERROR_LOCATION_HAS_BEEN_REGISTERED_BY_BIKE',
    NO_BIKE_FIND_AT_LOCATION: 'NO_BIKE_FIND_AT_LOCATION',
    ERROR_REGION_DOES_NOT_EXIST: 'ERROR_REGION_DOES_NOT_EXIST',
    ERROR_PROVINCE_DOES_NOT_EXIST: 'ERROR_PROVINCE_DOES_NOT_EXIST',
    ERROR_OPTIONAL_DOES_NOT_EXIST: 'ERROR_OPTIONAL_DOES_NOT_EXIST',
    ERROR_OPTIONAL_NAME_IS_EMPTY: 'ERROR_OPTIONAL_NAME_IS_EMPTY',
    ERROR_OPTIONAL_PRICE_IS_EMPTY: 'ERROR_OPTIONAL_PRICE_IS_EMPTY',
    ERROR_OPTIONAL_FORMAT_IS_EMPTY: 'ERROR_OPTIONAL_FORMAT_IS_EMPTY',
    ERROR_OPTIONAL_STATUS_IS_EMPTY: 'ERROR_OPTIONAL_STATUS_IS_EMPTY',
    ERROR_OPTIONAL_TYPE_VALUE_IS_EMPTY: 'ERROR_OPTIONAL_TYPE_VALUE_IS_EMPTY',
    ERROR_BIKE_DOES_NOT_EXIST: 'ERROR_BIKE_DOES_NOT_EXIST',
    BIKE_HAS_BOOKED: 'BIKE_HAS_BOOKED',
    ERROR_EMPTY_VEHICLE_LIST: 'ERROR_EMPTY_VEHICLE_LIST',
    VEHIVLE_NOT_PENDING_APPROVAL_STATUS: 'VEHIVLE_NOT_PENDING_APPROVAL_STATUS',
    ONLY_BIKE_IN_REJECT_STATUS_CAN_SEND_REQUEST: 'ONLY_BIKE_IN_REJECT_STATUS_CAN_SEND_REQUEST',
    APPROVE_VEHICLE_NOT_UPDATED: 'APPROVE_VEHICLE_NOT_UPDATED',
    THIS_ACCOUNT_EXCEEDED_NUMBER_OF_VEHICLE_CREATED: 'THIS_ACCOUNT_EXCEEDED_NUMBER_OF_VEHICLE_CREATED',
    ERROR_NON_RENTAL_DATES_DOES_NOT_EXIST: 'ERROR_NON_RENTAL_DATES_DOES_NOT_EXIST',
    ERROR_NON_RENTAL_DATES_EXIST: 'ERROR_NON_RENTAL_DATES_EXIST',
    ERROR_NON_RENTAL_DATES_OVERLAP_BOOKING: 'ERROR_NON_RENTAL_DATES_OVERLAP_BOOKING',
    INVALID_TYPE: 'INVALID_TYPE',
    ERROR_PRICE_DOES_NOT_EXIST: 'ERROR_PRICE_DOES_NOT_EXIST',
    ERROR_LOCATION_USE_FOR_PRICE: 'ERROR_LOCATION_USE_FOR_PRICE',
    ERROR_CAMPAIN_DOES_NOT_EXIST: 'ERROR_CAMPAIN_DOES_NOT_EXIST',
    CAMPAIN_INACTIVE: 'CAMPAIN_INACTIVE',
    COUPON_CREATED_SUCCESSFULLY: 'COUPON_CREATED_SUCCESSFULLY',
    MAXINUM_RETRIES_RTEACHED: 'MAXINUM_RETRIES_RTEACHED',
    MAMAXINUM_COUPON_CREATE: 'MAMAXINUM_COUPON_CREATE',
    COUPON_HAS_BEEN_USED: 'COUPON_HAS_BEEN_USED',
    COUPON_DOES_NOT_EXIST: 'COUPON_DOES_NOT_EXIST',
    AN_ACCOUNT_CAN_ONLY_HAVE_ONE_CODE_USED_AT_A_TIME: 'AN_ACCOUNT_CAN_ONLY_HAVE_ONE_CODE_USED_AT_A_TIME',
    INCORRECT_COUPON_TYPE: 'INCORRECT_COUPON_TYPE',
    CODE_NOT_WITHIN_REGISTRATION_PERIOD: 'CODE_NOT_WITHIN_REGISTRATION_PERIOD',
    COUPON_NOT_REGISTERED: 'COUPON_NOT_REGISTERED',
    PRESENT_TENSE_NOT_INCLUDED_IN_THE_TIME_USED: 'PRESENT_TENSE_NOT_INCLUDED_IN_THE_TIME_USED',
    COUPON_NOT_FOUND_OR_INVALID: 'COUPON_NOT_FOUND_OR_INVALID',
    ERROR_ORDER_DOES_NOT_EXIST: 'ERROR_ORDER_DOES_NOT_EXIST',
    BIKE_NOT_APPROVAL_OR_RENTAL_DATE_NOT_MATCH: 'BIKE_NOT_APPROVAL_OR_RENTAL_DATE_NOT_MATCH',
    RENTAL_PERIOD_MUST_BE_MORE_THAN_RENTAL_RESERVATION_DEADLINE: 'RENTAL_PERIOD_MUST_BE_MORE_THAN_RENTAL_RESERVATION_DEADLINE',
    BIKE_BEING_BOOKING: 'BIKE_BEING_BOOKING',
    ERROR_ORDER_UNPAID: 'ERROR_ORDER_UNPAID',
    ERROR_ORDER_CAN_NOT_HAVE_PERMISSION_CANCEL: 'ERROR_ORDER_CAN_NOT_HAVE_PERMISSION_CANCEL',
    PAYMENT_ORDER_NOT_FOUND: 'PAYMENT_ORDER_NOT_FOUND',
    ERROR_REVENUE_COMMISSION_DOES_NOT_EXIST: 'ERROR_REVENUE_COMMISSION_DOES_NOT_EXIST',
    ERROR_COMMISSION_SETTING_DOES_NOT_EXIST: 'ERROR_COMMISSION_SETTING_DOES_NOT_EXIST',
    ERROR_ORDER_STATUS_MUST_BE_PAID: 'ERROR_ORDER_STATUS_MUST_BE_PAID',
    ERROR_OCR_CANNOT_GET_CHRONOLOGY: 'ERROR_OCR_CANNOT_GET_CHRONOLOGY',
    ERROR_OCR_NO_MACHINE_READABLE_ZOME: 'ERROR_OCR_NO_MACHINE_READABLE_ZOME',
    ERROR_RENTAL_FROM_TO_TIME_INVALID: 'ERROR_RENTAL_FROM_TO_TIME_INVALID',
    ERROR_DOES_NOT_DELETE_ACCOUNT_OWNER_BIKE: 'ERROR_DOES_NOT_DELETE_ACCOUNT_OWNER_BIKE',
    ERROR_DOES_NOT_DELETE_ACCOUNT_ENDUSER_BOOKING_ONLY_INACTIVE: 'ERROR_DOES_NOT_DELETE_ACCOUNT_ENDUSER_BOOKING_ONLY_INACTIVE',
    ERROR_CANNOT_INACTIVE_ACCOUNT_BECAUSE_BOOKING_EXIST: 'ERROR_CANNOT_INACTIVE_ACCOUNT_BECAUSE_BOOKING_EXIST'
};
// #endregion Server Error Message Code

// #region Register Status
export const REGISTER_STATUS_LIST = [
    {
        name: 'words_title.registered',
        value: Boolean(REGISTER_STATUS.REGISTERED).valueOf()
    },
    {
        name: 'words_title.not_register',
        value: Boolean(REGISTER_STATUS.UNREGISTER).valueOf()
    }
];
// #endregion

// #region Vehicle arrangement time
export const VEHICLE_ARRANGEMENT_TIME_CONFIG = {
    1: { id: 1, prepareBefore: 7 },
    2: { id: 2, prepareBefore: 8 },
    3: { id: 3, prepareBefore: 9 },
    4: { id: 4, prepareBefore: 10 },
    5: { id: 5, prepareBefore: 11 },
    6: { id: 6, prepareBefore: 6 },
    7: { id: 7, prepareBefore: 7 },
    8: { id: 8, prepareBefore: 8 },
    9: { id: 9, prepareBefore: 9 },
    10: { id: 10, prepareBefore: 10 },
    11: { id: 11, prepareBefore: 11 },
    12: { id: 12, prepareBefore: 5 },
    13: { id: 13, prepareBefore: 6 },
    14: { id: 14, prepareBefore: 7 },
    15: { id: 15, prepareBefore: 4 },
    16: { id: 16, prepareBefore: 5 },
    17: { id: 17, prepareBefore: 6 },
    18: { id: 18, prepareBefore: 7 },
    19: { id: 19, prepareBefore: 7 },
    20: { id: 20, prepareBefore: 8 },
    21: { id: 21, prepareBefore: 9 },
    22: { id: 22, prepareBefore: 4 },
    23: { id: 23, prepareBefore: 5 },
    24: { id: 24, prepareBefore: 6 }
};
// #endregion

// #region Bike return
export enum CheckBikeBeforeReturnEnum {
    GasFull = 1,
    HandleLock = 2,
    Scratches = 3
}

export const CHECK_BIKE_BEFORE_RETURN_GAS = {
    [CheckBikeBeforeReturnEnum.GasFull]: {
        value: CheckBikeBeforeReturnEnum.GasFull,
        name: 'return_bike_form.check_box.gas_full'
    },
    [CheckBikeBeforeReturnEnum.HandleLock]: {
        value: CheckBikeBeforeReturnEnum.HandleLock,
        name: 'return_bike_form.check_box.handle_lock'
    },
    [CheckBikeBeforeReturnEnum.Scratches]: {
        value: CheckBikeBeforeReturnEnum.Scratches,
        name: 'return_bike_form.check_box.please_check_there_are_any_scratches'
    }
};

export const CHECK_BIKE_BEFORE_RETURN_EK = {
    [CheckBikeBeforeReturnEnum.GasFull]: {
        value: CheckBikeBeforeReturnEnum.GasFull,
        name: 'return_bike_form.check_box.turned_off_power'
    },
    [CheckBikeBeforeReturnEnum.HandleLock]: {
        value: CheckBikeBeforeReturnEnum.HandleLock,
        name: 'return_bike_form.check_box.please_check_there_are_any_scratches'
    }
};
// #endregion

// #region Step
export const STEP = {
    STEP_1: 1,
    STEP_2: 2
};
// #endregion
// #region Honorific title select
export const HONORIFIC_TITLE_SELECT = [
    {
        value: HONORIFIC_TITLE_TYPE.COMPANY,
        name: 'field.issue_invoice.company'
    },
    {
        value: HONORIFIC_TITLE_TYPE.PERSONAL,
        name: 'field.issue_invoice.personal'
    }
];
// #endregion Honorific title select

// #region Setting Mileage limit And Drop Off
export const GROUP_CAPACITY_BIKE = {
    [GROUP_CAPACITY_TYPE.LQ_125CC]: [CAPACITY_BIKE.MOPED, CAPACITY_BIKE.MOPED_2],
    [GROUP_CAPACITY_TYPE.GQ_126CC]: [CAPACITY_BIKE.A250CC, CAPACITY_BIKE.A400CC, CAPACITY_BIKE.GT400CC, CAPACITY_BIKE.PREMIUM, CAPACITY_BIKE.TRIKE]
};

export const MILEAGE_LIMIT_GROUP = {
    'capacity125cc': {
        label: '原付・新基準原付・原付2種',
        km: '30',
        value: GROUP_CAPACITY_TYPE.LQ_125CC
    },
    'capacity126cc': {
        label: '126cc以上',
        km: '50',
        value: GROUP_CAPACITY_TYPE.GQ_126CC
    }
};

export const MILEAGE_LIMIT_FIELD = {
    over24hKm: {
        label: '24時間',
        field: 'over24hKm'
    },
    over48hKm: {
        label: '25~48時間',
        field: 'over48hKm'
    },
    over72hKm: {
        label: '49~72時間',
        field: 'over72hKm'
    },
    over96hKm: {
        label: '73~96時間',
        field: 'over96hKm'
    },
    price: {
        label: '料金',
        field: 'price'
    }
};
// #endregion

// #region Bike GAS Transmission
export const GEARBOX_SELECT = [
    {
        value: GEARBOX.MT,
        name: 'words_title.mt'
    },
    {
        value: GEARBOX.AT,
        name: 'words_title.at'
    }
];

// #region Bike GAS Seat height (足付き)
export const SEAT_HEIGHT_SELECT = [
    { value: SEAT_HEIGHT.HIGH, name: 'field.seat_height_high' },
    { value: SEAT_HEIGHT.SLIGHTLY_HIGH, name: 'field.seat_height_slightly_high' },
    { value: SEAT_HEIGHT.STANDARD, name: 'field.seat_height_standard' },
    { value: SEAT_HEIGHT.SLIGHTLY_LOW, name: 'field.seat_height_slightly_low' },
    { value: SEAT_HEIGHT.LOW, name: 'field.seat_height_low' }
];

// #region Break symbol
export const BREAK_CHARS = ['（', '(', '・', '～', '~'] as const;

// Tạo regex như: /[（）()・～~]/
export const breakRegex = new RegExp(
    `[${BREAK_CHARS.map(c => `\\${c}`).join('')}]`
);
// #endregion
